<template>
  <div class="alert" @touchmove.prevent>
    <div class="mask" @touchmove.prevent></div>
    <div class="alert-box" v-if="type === ''">
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: "alertPage",
  props: {
    type: {
      type: String,
      default: "",
    },
  },
  methods: {
    close() {
      this.$emit("close", "close");
    },
  },
};
</script>
<style lang="less" scoped>
.alert {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99;
  .mask {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
  }
  .alert-box {
    position: relative;
    width: 7.5rem;
    height: 100%;
  }
}
</style>